<template>
  <div class="bg2">
    <!-- <Header title="我的优惠券" background="#ffffff"></Header> -->
    <van-tabs v-model="status" title-active-color="#FD0212">
      <van-tab :title="item.name" :name="item.id" v-for="(item, index) in nav" :key="item.id">
      </van-tab>
    </van-tabs>
    <div class="lists">
      <div v-for="item in list" :class="['list', { list2: status == 1 }]">
        <div class="listLeft">
          <span>{{item.cutMoney}}</span>
          <span>元</span>
        </div>
        <div class="listRight flex-between">
          <div class="top">
            <h5>满{{item.fullMoney}}可用</h5>
            <p>{{item.endTimeAt}}前有效</p>
          </div>
          <div class="bottom" v-if="status == 1">
            <span>立即使用</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      nav: [
        {
          name: "已领取",
		  id:1
        },
        {
          name: "已使用",
		  id:2
        },
        {
          name: "已过期",
		  id:3
        },
      ],
	  status: 1, // 商品分类ID。若不指定分类则传0
	  form: {
	    lastId: 0, // 必选 最新ID。首次传0，之后传接口返回的lastId
	    page: 1, // 必选 请求数据页码
	    
	  },
	  list:[]
    };
  },
  computed: {},
  mounted() {
  	this.getInfo()
  },
  watch:{
	   status(val){
		   this.form.lastId=0;
		   this.form.page=1;
		   this.list=[]
		   this.getInfo()
	   }
  },
  methods: {
	  getInfo() {
	    this.$post({
	      module: "User",
	      interface: "6003",
	      data: {
			  status:this.status,
			  page:this.form.page,
			  lastId:this.form.lastId
		  },
	    }).then((res) => {
			// this.list = res
			
			this.form.lastId = res.lastId;
			this.form.page++;
			this.finished = res.currentPage >= res.lastPage;
			this.list = this.list.concat(res.list);
			this.loading = false;
	    });
	  },
  },
};
</script>

<style lang='less' scoped>
.lists {
  margin: 0 16px;
  .list {
    background-image: url("../../assets/home/yhq_yishiyong_bg@2x (1).png");
    background-size: 100% 100%;
    height: 94px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 14px;
    .listLeft {
      flex: 1;
      color: #ffffff;
      text-align: center;
      span:nth-child(1) {
        font-size: 44px;
      }
      span:nth-child(2) {
        font-size: 12px;
      }
    }
    .listRight {
      font-size: 12px;
      flex: 2;

      .top {
        flex-direction: column;
        justify-content: space-between;
        h5 {
          font-size: 17px;
          margin-bottom: 20px;
        }
        p {
          color: #919398;
        }
      }
      .bottom {
        display: flex;
        span {
          width: 64px;
          height: 22px;
          background: #fd0212;
          color: #ffffff;
          border-radius: 14px;
          text-align: center;
          line-height: 22px;
        }
        img {
          width: 80px;
          height: 80px;
        }
      }
    }
  }
  .list2 {
    background-image: url("../../assets/home/yhq_blue_bg@2x.png");
  }
}
</style>
